<template>
    <div class="col-sm-12 py-3">
        <div v-if="reservation.billing.payments">
            <div class="d-flex flex-row justify-content-between" v-for="payment in reservation.billing.payments">
                <span>{{payment.date}}</span>
                <span>{{payment.value + ' ' + payment.currency }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {

        }
    },
    props: {
        reservation: {
            type: Object
        }
    },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TabPayments.vue?5f2a69d4